import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

/**
 * Google Shopping product availability status
 * @see https://developers.google.com/shopping-content/reference/rest/v2.1/products#Availability
 */
export enum GoogleShoppingAvailability {
  InStock = "in_stock",
  OutOfStock = "out_of_stock",
  Preorder = "preorder",
  Backorder = "backorder",
}
export const GoogleShoppingAvailabilitySchema = createEnum(
  GoogleShoppingAvailability,
  { enumName: "GoogleShoppingAvailability" },
);

/**
 * Google Shopping product condition
 * @see https://developers.google.com/shopping-content/reference/rest/v2.1/products#Condition
 */
export enum GoogleShoppingCondition {
  New = "new",
  Refurbished = "refurbished",
  Used = "used",
}
export const GoogleShoppingConditionSchema = createEnum(
  GoogleShoppingCondition,
  { enumName: "GoogleShoppingCondition" },
);

/**
 * Google Shopping age group
 */
export enum GoogleShoppingAgeGroup {
  Adult = "adult",
  Kids = "kids",
  Toddler = "toddler",
  Infant = "infant",
  Newborn = "newborn",
}
export const GoogleShoppingAgeGroupSchema = createEnum(GoogleShoppingAgeGroup, {
  enumName: "GoogleShoppingAgeGroup",
});

/**
 * Google Shopping gender
 */
export enum GoogleShoppingGender {
  Male = "male",
  Female = "female",
  Unisex = "unisex",
}
export const GoogleShoppingGenderSchema = createEnum(GoogleShoppingGender, {
  enumName: "GoogleShoppingGender",
});

/**
 * Google Shopping price schema
 */
const GoogleShoppingPriceSchema_ = z.object({
  value: z.string(),
  currency: z.string(),
});
export const GoogleShoppingPriceSchema: z.ZodType<GoogleShoppingPrice> =
  GoogleShoppingPriceSchema_;
export interface GoogleShoppingPrice
  extends z.infer<typeof GoogleShoppingPriceSchema_> {}

/**
 * Google Shopping shipping weight schema
 */
const GoogleShoppingShippingWeightSchema_ = z.object({
  value: z.number(),
  unit: z.string(),
});
export const GoogleShoppingShippingWeightSchema: z.ZodType<GoogleShoppingShippingWeight> =
  GoogleShoppingShippingWeightSchema_;
export interface GoogleShoppingShippingWeight
  extends z.infer<typeof GoogleShoppingShippingWeightSchema_> {}

/**
 * Google Shopping shipping dimension schema
 */
const GoogleShoppingShippingDimensionSchema_ = z.object({
  value: z.number(),
  unit: z.string(),
});
export const GoogleShoppingShippingDimensionSchema: z.ZodType<GoogleShoppingShippingDimension> =
  GoogleShoppingShippingDimensionSchema_;
export interface GoogleShoppingShippingDimension
  extends z.infer<typeof GoogleShoppingShippingDimensionSchema_> {}
